<template>
  <div class="c-query">
    <slot name="front"></slot>
    <div class="item">
      <span>选择分组：</span>
      <span style="min-width: 200px;">{{ group.groupTitle }}</span>
    </div>
    <div class="item">
      <span>选择设备：</span>
      <span style="min-width: 200px;">{{ device.deviceTitle }}</span>
    </div>
    <div class="item">
      <div id="datePicker">
        <div class="start">
          <span class="demonstration">开始日期:</span>
          <el-date-picker class="date" v-model="time_value[0]" type="date" placeholder="开始日期" value-format="yyyyMMdd">
          </el-date-picker>
        </div>
        <div class="end">
          <span class="demonstration">结束日期:</span>
          <el-date-picker class="date" v-model="time_value[1]" type="date" placeholder="结束日期" value-format="yyyyMMdd">
          </el-date-picker>
        </div>
      </div>
    </div>
    <div class="item">
      <el-button type="primary" icon="el-icon-search" @click="onEvent('query')">查询</el-button>
    </div>
    <slot name="behind"></slot>
  </div>
</template>

<script>
export default {
  data() {
    return {
      device: {
        uid: '',
        deviceTitle: ''
      },
      time_value: [],
      group: {
        groupId: '',
        groupTitle: ''
      },

    }
  },
  watch: {
    '$store.state.curTreeData': {
      handler(val) {
        // console.log(6666, val);
        const curData = val[0];
        //选择了节点
        if (curData.type == "org" && curData.groupId) {
          this.group.groupId = curData.groupId;
          this.group.groupTitle = curData.title;
          this.device.deviceTitle = '';
          this.device.uid = '';
        }
        //选择了设备
        if (curData.type == "device") {
          this.device.uid = curData.uid;
          this.device.deviceTitle = curData.title != "" ? curData.title : curData.uid;
          this.group.groupTitle = '';
          this.group.groupId = '';
        }
      },

    }
  },
  methods: {
    handlerGroup(val) { },
    handlerDevice(val) {
    },
    onEvent(e) {
      if (e != 'query') {
        return
      }
      const groupMode = this.$store.state.settingStore.groupMode
      console.log(111, groupMode);

      if (!groupMode) {
        this.$message.error('请在分组模式下操作！');
        return
      }
      if (this.group.groupId == '' && this.device.uid == '') {
        this.$message.error('请选择设备或分组！');
        return
      }

      if (this.time_value[0] == void 0 || this.time_value[1] == void 0) {
        this.$message.error('请选择日期！');
        return

      }
      // 设置正在查询的状态到store中
      this.$store.commit('settingStore/SET_MONITORSTATE', true);
      let cJson = {}
      if (this.group.groupId != '') {
        cJson = {
          cmd: "checkGroup",
          "groupId": this.group.groupId,
        }
      }
      if (this.device.uid != '') {
        cJson = {
          cmd: "checkDevice",
          "uid": this.device.uid,
        }
      }
      let json = {
        "startDate": this.time_value[0],//开始日期
        "stopDate": this.time_value[1],//结束日期
      }
      // console.log(5555, json);
      this.ws.send({ ...cJson, ...json });
    },
  }
}
</script>

<style lang="scss" scoped>
.demonstration {
  padding: 10px;
}
.start {
  float: left;
  margin-right: 10px;
}
.end {
  float: left;
}
.date {
  width: 130px !important;
  font-size: 12px !important;
}
</style>